/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespNullSearchResultsHeader_searchBrowse = {|
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResultsHeader_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
